import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  TextField,
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";
import Image from "../assets/3275432.svg";
import { Link } from "react-router-dom";
import "./login.css";
import { API_URL } from "../Config";
import SnackBarComponent from "../SnackBar/SnackBar";
class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      // phonenumber: "",
      password1: "",
      userData: undefined,
      id: undefined,
      password: undefined,
      loading: false,
      forgot: true,
      isMail: true,
      isSms: false,
      phonenoErrorText: "",
      emailErrorText: "",
      open: false,
      severity: "",
      alertmsg: "",
      connectionError: "",
      disabled: false,
      options:[{name:"Email",value:"Email"},{name:"SMS",value:"SMS"}]
    };
  }

  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "email") this.setState({ emailErrorText: "" });
    else this.setState({ phonenoErrorText: "" });
  };
  validateForm = () => {
    const validEmailRegex = RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    let { email, emailErrorText } = this.state;
    // if (isMail) {
    if (!email) emailErrorText = "Please enter email address";
    else if (!validEmailRegex.test(email.trim()))
      emailErrorText = "Invalid email address";
    // }
    if (!emailErrorText) {
      return true;
    } else {
      this.setState({ emailErrorText });
      return false;
    }
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (!this.state.isMail && !this.state.isSms) {
      // this.setState({
      //   open: true,
      //   severity: "warning",
      //   alertmsg: "Please select a mode to send OTP",
      // });
      this.setState({ connectionError: "Please select one of them" });
    } else {
      if (this.validateForm()) {
        this.setState({ disabled: true });
        let verificationCodeTo =
          this.state.isMail && this.state.isSms
            ? "both"
            : this.state.isMail
            ? "email"
            : this.state.isSms
            ? "sms"
            : "";
        fetch(
          `${API_URL}/api/Userdata/two-factor-login?email=${this.state.email}&verificationCodeTo=${verificationCodeTo}`,
          {
            method: "POST",
            mode: "cors",
            body: JSON.stringify({
              // query: Query,
              // variables: Variables,
            }),
            headers: {
              "Content-type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((res) => {
            this.setState({ disabled: false });
            if (res.data) {
              if (res.data.status === "success") {
                localStorage.setItem("email", this.state.email);
                this.props.history.push({
                  pathname: "/verifyOtp",
                  state: {
                    message: res.data.message,
                    email: this.state.email,
                    type: this.props.location.pathname,
                    verificationCodeTo: verificationCodeTo,
                  },
                });
              } else {
                this.setState({
                  severity: "error",
                  open: true,
                  alertmsg: res.data.message,
                  timer: 3000,
                });
              }
            } else {
              const message = res.message;
              this.setState({
                disabled: false,
                connectionError: message,
              });
            }
          })
          .catch((e) => {
            this.setState({
              disabled: false,
              connectionError: e.message,
            });
          });
      }
    }
  };

  goBack = () => {
    this.props.history.push("/");
  };
  BacktoLogin = () => {
    localStorage.clear();
  };
  handleCheckbox = (e) => {
    let { name, checked } = e.target;
    if (name === "Email") {
      this.setState({
        isMail: checked,
        emailErrorText: "",
        connectionError: "",
        isSms: checked ? !checked : checked,
      });
    } else {
      this.setState({
        isSms: checked,
        phonenoErrorText: "",
        connectionError: "",
        isMail: checked ? !checked : checked,
      });
    }
  };
  handleClose = () => {
    this.setState((prevState) => {
      return {
        open: !prevState.open,
      };
    });
  };
  render() {
    const options = this.state.options.map((item, i) => {
      return (
        <FormControlLabel
          key={i}
          value={item.value}
          control={<Radio />}
          label={item.name}
        />
      );
    });
    return (
      <div className="loginOtpSection">
        <div className="logoimg">
          <img src={Image} alt="uptake Medical" />
        </div>
        <h4>FORGOT PASSWORD?</h4>
        <form noValidate onSubmit={this.onSubmit}>
          <TextField
            value={this.state.email}
            margin="normal"
            fullWidth
            id="email"
            name="email"
            // placeholder="Email Address"
            autoComplete="email"
            autoFocus
            onChange={this.handleChange}
            // error={!this.state.emailErrorText ? false : true}
            helperText={this.state.emailErrorText}
            label="Email Address"
          />
          {this.state.connectionError ? (
            <div className="connectionError">
              <p>{this.state.connectionError}</p>
            </div>
          ) : (
            ""
          )}
          <p>
            To verify your identity, a one time passcode (OTP) will be sent to you. Please
            choose which method you would prefer to receive your security code.
          </p>
          <Grid className="OtpSection">
            <h5>Send OTP over</h5>
            <ul>
              <li>
                <RadioGroup onChange={this.handleCheckbox} defaultValue="Email" className="radioBox">{options}</RadioGroup>
              </li>
            </ul>
          </Grid>

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={this.state.disabled}
          >
            Get OTP
          </Button>
          <span className="backtologin">
            <Link to="/" variant="body2" onClick={this.BacktoLogin}>
              Back to Login Page
            </Link>
          </span>
        </form>
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleClose}
          />
        ) : (
          ""
        )}
      </div>
    );
  }

  handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
}
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(null, mapDispatchToProps)(ForgotPassword);
